import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IUpdateWalletTagsPayload } from '@kattana-io/common';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { actionUpdateWalletTags } from '../../../actions/wallet_tags';

import minus from '../../../assets/images/minus.svg';

import './styles.scss';

const MODAL_WIDTH = 247;

interface IEditWalletTagModalProps {
  wallet: string;
  network: string;
  currentTag?: string;
  x?: number;
  y?: number;
  onCancel: () => void;
}

const EditWalletTagModal = ({
  wallet,
  network,
  currentTag,
  x = 0,
  y = 0,
  onCancel,
}: IEditWalletTagModalProps) => {
  const [tag, setTag] = useState(currentTag || '');

  const dispatch = useDispatch();

  const handleTagChange = (e: ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;

    if (text.length > 23 && text[24]) {
      setTag(text.slice(0, 23) + text[24]);
    } else {
      setTag(text);
    }
  };

  const handleUpdate = async () => {
    const payload: IUpdateWalletTagsPayload = {
      wallet,
      network,
      tags: [tag.trim()],
    };
    onCancel();
    dispatch(actionUpdateWalletTags(payload));
  };

  const handleRemove = async () => {
    const payload: IUpdateWalletTagsPayload = {
      wallet,
      network,
      tags: [''],
    };
    dispatch(actionUpdateWalletTags(payload));
    onCancel();
  };

  const screenWidth = window.document.body.clientWidth;

  let top = y;
  let left = x;
  if (y < 0) {
    top = 10;
  }
  if (screenWidth < MODAL_WIDTH + x) {
    left = screenWidth - MODAL_WIDTH - 10;
  } else if (x < 0) {
    left = 10;
  }

  return (
    <>
      <div className='edit_wallet_tag__backdrop' onClick={onCancel} />
      <div
        className='edit_wallet_tag'
        style={{
          top,
          left,
        }}
      >
        <div className='edit_wallet_tag__header'>
          <div className='edit_wallet_tag__header__logo icon-bookmark' />
          <Text size={14} className='text--grey-200'>
            Edit wallet tag
          </Text>
          <div className='edit_wallet_tag__header__close' onClick={onCancel}>
            <Image size='s' src={minus} alt='close edit modal' />
          </div>
        </div>
        <div className='edit_wallet_tag__body'>
          <div className='edit_wallet_tag__body__edit'>
            <Text size={14} className='text--grey-400 text--weight-600'>
              Tag:
            </Text>
            <input
              type='text'
              className='field'
              value={tag}
              onChange={handleTagChange}
              autoFocus
              spellCheck={false}
            />
          </div>

          <div className='edit_wallet_tag__body__actions'>
            <Button
              text='Remove'
              action={handleRemove}
              size='s'
              variant='secondary'
              disabled={!currentTag}
            />
            <Button
              text='Update'
              action={handleUpdate}
              size='s'
              variant='primary'
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EditWalletTagModal;
